import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Text } from 'components/ui';
import Chevron from 'components/Chevron';
import { colors, space } from 'style/config';

function Avs({
    loqateAddresses = [],
    hasAddress1Focus = false,
    highlightedAddrIndex = -1,
    localization = {},
    onMouseLeaveList,
    onMouseEnterItem,
    onClickItem,
    getHighlight,
    addressPredictionRef
}) {
    const { keepTyping } = localization;
    const hasResults = !!(loqateAddresses && loqateAddresses.length > 0);

    const highlightAVSSearchTerm = (string, highlightStr) => {
        const highlights = highlightStr.split(';').shift();

        if (highlights) {
            let currentString = string;
            highlights.split(',').forEach(highlight => {
                const limits = highlight.split('-');
                const highlightText = string.substring(limits[0], limits[1]);
                currentString = currentString.replace(highlightText, `<b>${highlightText}</b>`);
            });

            return currentString;
        } else {
            return string;
        }
    };

    const highlightAVSUnits = string => {
        return string.replace(/\d+ Addresse?s?$/gi, '<b>$&</b>');
    };

    return (
        <Box
            is='ul'
            overflowY='auto'
            lineHeight='tight'
            maxHeight={370}
            position='absolute'
            top='100%'
            marginTop={`-${space[4]}px`}
            left={0}
            right={0}
            padding={2}
            borderRadius={2}
            backgroundColor='white'
            ref={addressPredictionRef}
            boxShadow='light'
            zIndex={1}
            role='listbox'
            aria-live='off' // Off b/c we have a separate aria-live region for status updates
            id='avs_listbox'
            onMouseLeave={onMouseLeaveList}
            style={
                !(hasAddress1Focus && hasResults)
                    ? {
                        display: 'none'
                    }
                    : null
            }
        >
            <li
                role='status'
                aria-live='polite'
                aria-atomic='true'
                style={{ listStyle: 'none' }}
            >
                <Text
                    mx={3}
                    mb={3}
                    mt={1}
                    is='p'
                    id='avs_keep_typing_message'
                >
                    {keepTyping}
                </Text>
            </li>

            {hasResults &&
                loqateAddresses.map((loqateAddress, index) => {
                    const isActive = index === highlightedAddrIndex;
                    const highlight = getHighlight(loqateAddress);

                    return (
                        <li
                            key={loqateAddress.Id || index.toString()}
                            role='option'
                            aria-selected={isActive}
                            id={`avs_result${index}`}
                            css={[styles.avsItem, isActive && styles.avsItemActive]}
                            onMouseEnter={() => onMouseEnterItem(index)}
                            onClick={() => onClickItem(loqateAddress)}
                        >
                            <div css={styles.avsItemInner}>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: highlightAVSSearchTerm(loqateAddress.Text, highlight)
                                    }}
                                />
                                <div
                                    css={styles.avsItemDesc}
                                    dangerouslySetInnerHTML={{
                                        __html: highlightAVSUnits(loqateAddress.Description)
                                    }}
                                />
                            </div>
                            {loqateAddress.Type !== 'Address' && (
                                <Chevron
                                    marginLeft={2}
                                    direction='right'
                                />
                            )}
                        </li>
                    );
                })}
        </Box>
    );
}

const styles = {
    avsItem: {
        display: 'flex',
        alignItems: 'center',
        padding: space[3],
        cursor: 'pointer',
        '& + *': {
            borderTop: `1px solid ${colors.lightGray}`
        }
    },
    avsItemActive: {
        position: 'relative',
        backgroundColor: colors.nearWhite
    },
    avsItemInner: {
        flex: 1
    },
    avsItemDesc: {
        color: colors.gray
    }
};

export default wrapFunctionalComponent(Avs, 'Avs');
